import { render } from "./homePrivate.vue?vue&type=template&id=584fe9f6&scoped=true"
import script from "./homePrivate.vue?vue&type=script&lang=js"
export * from "./homePrivate.vue?vue&type=script&lang=js"

import "./homePrivate.vue?vue&type=style&index=0&id=584fe9f6&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584fe9f6"]])

export default __exports__